"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Status = require("../Status");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
/**
 * Fetch
 *
 * This object is meant to help facilitate information about a Fetch
 * action to the UI.
 *
 * Since we are promoting immutability please always instantiate a new
 * Fetch instead of modifying an existing fetches properties. There is
 * a convinience method available for copying, cloneFetch().
 *
 * NOTE: We might move these methods into a State class as we flesh out how
 * we store data in Reducers.
 */


var Fetch = /*#__PURE__*/function () {
  /**
   * @param {string} identifier A unique identifier, used to cache the fetch typically on a reducer.
   * @param {string[]} ids The ids fetched or used to be fetched.
   * @param {Object[]} objects The objects fetched.
   * @param {Object} data The full data object.
   * @param {Status} status The state of the fetch.
   */
  function Fetch(identifier) {
    var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var objects = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var status = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new _Status.Status();

    _classCallCheck(this, Fetch);

    this.identifier = identifier;
    this.ids = ids || [];
    this.objects = objects || [];
    this.status = status || new _Status.Status();
    this.data = data;
    this.createdAt = Date.now();
  }
  /**
   * Allows the creation of a fetch object with a single id/object.
   *
   * @param {string} identifier A unique identifier, used to cache the fetch typically on a reducer.
   * @param {string} id The id fetched or used to be fetched.
   * @param {Object[]} objects The objects fetched.
   * @param {Status} status The state of the fetch.
   */


  _createClass(Fetch, [{
    key: "id",

    /**
     * Returns the first object in the 'ids' array.
     */
    value: function id() {
      return this.ids[0] || null;
    }
    /**
     * Returns the first object in the 'objects' array
     */

  }, {
    key: "object",
    value: function object() {
      return this.objects[0] || null;
    }
  }], [{
    key: "single",
    value: function single(identifier, id, object, data, status) {
      var objects = object ? [object] : [];
      var ids = id ? [id] : [];
      return new Fetch(identifier, ids, objects, data, status);
    }
  }]);

  return Fetch;
}();

var _default = Fetch;
exports["default"] = _default;